import moment from "moment"

export const getSCDRegisterDate = (data) => {
  if (!data || !Array.isArray(data) || !data.length) {
    return []
  }

  return [
    ...new Set([
      ...data
        .map((item) => moment(`${item?.year}-${item?.month}-${item?.day}`).format("YYYY-MM-DD"))
        .sort((a, b) => moment(b) - moment(a)),
    ]),
  ]
}

export const groupEventsByMonth = (data, dateKey) => {
  if (!data || !data.length) {
    return []
  }

  const eventList = [...new Set(data.map((item) => item?.evento))];
  const monthList = [...new Set(data.map(item => item?.event_month))];
  const yearList = [...new Set(data.map(item => item?.year_event))];
  let groupedData = [];

  eventList.map(event_name => {
    yearList.map(year => {
      monthList.map(month => {
        const eventData = data.filter(row =>
          row?.evento === event_name && 
          row?.year_event === year && 
          row?.event_month === month
        );

        if(eventData && eventData.length) {
          groupedData.push({
            event_month: month,
            year_event: year,
            evento: event_name,
            qtde_produtor: eventData.reduce((currentValue, item) => (item?.qtde_produtor + currentValue), 0) || 0,
            event_date: moment(`01-${month}-${year}`, 'DD-MM-YYYY').format('YYYY-MM-DD')
          })
        }
        return month
      })
      return year
    })
    return event_name
  })

  return {
    eventList,
    monthList,
    yearList,
    groupedData: groupedData.sort((a, b) => {
      if (a?.event_date < b?.event_date) return -1
      if (a?.event_date > b?.event_date) return 1
      return 0
    })
  }
}

export const getLastRegisterData = (data, yearKey = "year", filteredYear) => {
  if (!data || !Array.isArray(data) || !data.length) {
    return []
  }

  const lastRegisterDate = getSCDRegisterDate(data)[0]
  
  if (!lastRegisterDate) return []

  const dataToReturn = data.filter(
    (item) =>
      moment(`${item?.year}-${item?.month}-${item?.day}`).format("YYYY-MM-DD") === lastRegisterDate,
  )

  const years = getDataYears(dataToReturn, yearKey)

  if (!filteredYear) {
    filteredYear = years[0]
  }

  return [
    filteredYear ? dataToReturn.filter((item) => item[yearKey] == filteredYear) : dataToReturn,
    years[0],
  ]
}

export const getDataYears = (data, key = "year") => {
  if (!data || !Array.isArray(data) || !data.length) {
    return null
  }

  const years = [...new Set([...data.map((item) => item[key])].sort((a, b) => b - a))]

  return years
}

export const getCurrentPercent = (data = [], totalKeyToCompare, percentKey, yearKey = "year") => {
  if (!data || !Array.isArray(data) || !data.length) {
    return 0
  }

  const [currentYear, lastYear] = getDataYears(data, yearKey)

  if (!currentYear) {
    return 100
  }

  const currentTotalToCompare = data
    .filter((item) => item[yearKey] == currentYear)
    .reduce((value, item) => value + item[totalKeyToCompare], 0)
  const lastTotalToCompare = data
    .filter((item) => item[yearKey] == lastYear)
    .reduce((value, item) => value + item[totalKeyToCompare], 0)

  const currentData = data
    .filter((item) => item[yearKey] == currentYear)
    .reduce((value, item) => value + item[percentKey], 0)
  const lastData = data
    .filter((item) => item[yearKey] == lastYear)
    .reduce((value, item) => value + item[percentKey], 0)

  const [currentPercent, lastPercent] = [
    getPercent(currentData, currentTotalToCompare),
    getPercent(lastData, lastTotalToCompare),
  ]

  if (currentPercent && lastPercent) {
    return ((currentPercent / lastPercent) * 100 - 100).toFixed(1)
  }

  return currentPercent.toFixed(1)
}

const getPercent = (value, total) => {
  return (value * 100) / total || 0
}

export const getMeanByMonth = (data, monthKey = "month", meanKey) => {
  if (!data || !Array.isArray(data) || !data.length) {
    return []
  }

  const allMonths = [...new Set([...data.map((item) => item[monthKey])])]

  return allMonths
    .map((currentMonth) => {
      let [totalLength, dataSum, numNPS] = [0, 0, 0]

      data
        .filter((row) => row[monthKey] == currentMonth)
        .map((item) => {
          totalLength++
          dataSum += item[meanKey]
          numNPS += item?.num_nps || 0

          return item
        })

      return { month: currentMonth, mean: dataSum / totalLength || 0, numNPS }
    })
    .sort((a, b) => a?.month - b?.month)
}


export const getDataByTrimester = (data, yearKey = "year", filteredPeriod) => {
  if (!data || !Array.isArray(data) || !data.length) {
    return []
  }

  // pega a ultima data baseada no periodo setado no filtro, se existir referencia pega referencia, senão a data inicial)
  if(filteredPeriod){
    return formatDateChart(data[0])
  }

  const lastRegisterDate = getSCDRegisterDate(data)
 

  if (!lastRegisterDate) {
    return []
  }

  const groupedDates = groupByTrimester(lastRegisterDate)

  const result = Object.keys(groupedDates).map((key) => {
    const filteredDate = data.filter((item) => {
      const formattedDate = moment(`${item[yearKey]}-${item["month"]}-${item["day"]}`).format("YYYY-MM-DD");
      return groupedDates[key].includes(formattedDate);
    });
  
    const lastMonthFiltered = filteredDate.filter((item) => item["month"] === Math.max(...filteredDate.map((obj) => obj["month"])));
  
    const largestDay = Math.max(...lastMonthFiltered.map((obj) => obj["day"]));
    const lastDate = lastMonthFiltered.find((obj) => obj["day"] === largestDay);
  
    return {
      trimester: key,
      media: lastDate?.nps || 0,
    };
  });
  
  const reversedResult = result.reverse();
  
  return reversedResult;

};

export const getDataByFilterReference = (kpi) => {

  const kpiData = kpi?.data.length > 0 ? formatDateChart(kpi?.data[0]) : {}
  const kpiReference = kpi?.reference.length > 0 ? formatDateChart(kpi?.reference[0]) : {}
  let mergedKpiData = {}

  if (Object.keys(kpiData).length === 0) {
    mergedKpiData = kpiReference
  } else if (
    Object.keys(kpiReference).length === 0 ||
    kpiData[0]?.completeDate === kpiReference[0]?.completeDate
  ) {
    mergedKpiData = kpiData
  } else {
    mergedKpiData = [...kpiData, ...kpiReference]
  }


  const groupedData = Object.keys(mergedKpiData).length  > 0 && mergedKpiData?.reduce((grupos, data) => {
    const { completeDate } = data

    if (!grupos[completeDate]) {
      grupos[completeDate] = []
    }

    grupos[completeDate].push(data)

    return grupos
  }, {})

  const finalData = Object.values(groupedData).flat()

  return finalData
}

const groupByTrimester = (dates) => {
  let trimesters = {};

  dates.forEach((data) => {
    const [year, month] = data.split('-');

    let trimester;

    if (month >= 1 && month <= 3) {
      trimester = `1º Trimestre/${year}`;
    } else if (month >= 4 && month <= 6) {
      trimester = `2º Trimestre/${year}`;
    } else if (month >= 7 && month <= 9) {
      trimester = `3º Trimestre/${year}`;
    } else if (month >= 10 && month <= 12) {
      trimester = `4º Trimestre/${year}`;
    }

    if(!Object.keys(trimesters).includes("4º")) {
      const novachave = `4º Trimestre/${year}`;
      trimesters[novachave] = []
    }
    
    if (!trimesters[trimester]) {
      trimesters[trimester] = [];
    }

    trimesters[trimester].push(data);
  });

  return trimesters;
};

export const formatDateChart = (item) => ([{
  completeDate: `${item?.day} de ${moment(item?.month, "M").format("MMMM")} de ${item?.year}`,
  year: `${item?.year}`,
  media: item?.nps || 0,
}])
